module.exports = __webpack_public_path__ + "c8fd4b9f369ddda47cc905ff503c9b78.jpg";